import axios from "axios";
import { API_LIVE_URL } from "./configs/apiConfig";

// Get the current hostname and port
const hostname =
  (typeof window !== "undefined" &&
    window.location &&
    window.location.hostname) ||
  "localhost";

const port =
  typeof window !== "undefined" && process.env.NODE_ENV !== "production"
    ? ":5000"
    : "";

// Determine the base URL and API prefix based on the environment

let headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const getBaseConfig = () => {
  const baseURL = API_LIVE_URL;
  // process.env.NODE_ENV === "production"
  //   ? "https://bonusnow.onrender.com"
  //   : `http://${hostname}${port}`;

  return {
    baseURL: `${baseURL}/api/v1`,
    timeout: 30000, // 30 second timeout
    headers,
    // withCredentials: true,
  };
};

const config = getBaseConfig();

const axiosInstance = axios.create(config);

// Add a request interceptor to add Authorization header if token exists
axiosInstance.interceptors.request.use(
  (config) => {
    const customHeader = JSON.parse(config?.headers?.customHeader || "{}");

    if (
      customHeader &&
      typeof customHeader === "object" &&
      Object?.keys(customHeader)?.length > 0
    ) {
      config.headers = { ...headers, ...customHeader };
    }

    // Skip token for these routes
    const publicRoutes = [
      "/user-login",
      "auth/register",
      "auth/set-password",
      "auth/reset-password",
    ];

    if (!publicRoutes.some((route) => config.url?.includes(route))) {
      try {
        const token = localStorage.getItem("accessToken");
        if (
          token &&
          !(customHeader?.authorization || customHeader?.Authorization)
        ) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
      } catch (error) {
        console.warn("Unable to access localStorage:", error);
      }
    }

    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
axiosInstance.interceptors.response.use(
  (response) => {
    // Log successful response

    return response;
  },
  async (error) => {
    // Skip token refresh for these routes
    const skipRefreshRoutes = [
      "/user-login",
      "auth/register",
      "/refreshToken",
      "auth/set-password",
      "auth/reset-password",
    ];

    if (
      error.response?.status === 401 &&
      !skipRefreshRoutes.some((route) => error.config?.url?.includes(route))
    ) {
      try {
        const response = await axiosInstance.post("/refreshToken");
        const { accessToken } = response.data;

        try {
          localStorage.setItem("accessToken", accessToken);
        } catch (storageError) {
          console.warn("Unable to access localStorage:", storageError);
        }

        // Retry the original request
        const config = error.config;
        config.headers["Authorization"] = `Bearer ${accessToken}`;
        return axiosInstance(config);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
